import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const TenderListingContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "25px",
    width: '100%',
    backgroundColor: theme.palette.jigsaw.white,
}));
